import { Col, Divider, Radio, Row, Space, Tag, Typography } from 'antd'
import { Icon } from '@iconify/react';
import { useState } from 'react';
import CustomModal from '../CustomModal/CustomModal';
import "antd/dist/antd.css";
import { InfoItem } from './InfoItem';
import { AddStatusModalContent } from './AddStatusModalContent';
import { useQuery } from '@apollo/client';
import { GET_LEAD, GET_STATUS_FLOW } from '../../Graphql/queries/getQueries';
import Spiner from '../Spiner/Spiner';



const LeadInfo = ({ leadId }) => {
    const { error, loading, data } = useQuery(GET_LEAD, {
        variables: {
            value: leadId
        },
    })

    const { name, country, email, phone, city, device, region, status: LeadStatus, date, utm, campaign, user } = !loading && data?.Leads?.nodes[0]

    const status = [
        { value: 1, title: 'In process', color: '#FC7816' },
        { value: 2, title: 'Not intersted', color: '#00C771' },
        { value: 3, title: 'Follow up', color: '#7A16FC' },
        { value: 4, title: 'No response', color: '#CA321A' },
        { value: 5, title: 'Potentional', color: '#532612' },
        { value: 6, title: 'Registered', color: '#00C7C0' },
        { value: 7, title: 'Campus visit', color: '#1A37CA' },
        { value: 8, title: 'Reserved for 2024', color: '#AB008E' },
        { value: 9, title: 'Unprocessed', color: '#FCAA16' }
    ]
    const [open, setOpen] = useState(false);
    const [radioValue, setRadioValue] = useState(1);
    const [confirmLoading, setConfirmLoading] = useState(false);
    const [selectedStatus, setSelectedStatus] = useState({ value: 10, title: 'Unprocessed', color: '#FCAA16' });


    const showModal = () => {
        setOpen(true);
    };
    const handleOk = () => {
        setSelectedStatus(status.find(s => s.value === radioValue))
        // setConfirmLoading(true);
        // setTimeout(() => {
        //     setConfirmLoading(false);
        // }, 2000);
        setOpen(false);
    };
    const handleCancel = () => {
        console.log('Clicked cancel button');
        setOpen(false);
    };
    if (loading) return <Spiner />
    return (

        <Row className='lead_comp_container lead_info' >
            <Col lg={{ span: 7 }} sm={{ span: 11 }} xs={{ span: 24 }}   >
                {/* <Space direction="vertical" size="middle"> */}
                <InfoItem title='Full name' info={name} editable />
                <InfoItem title='Mobile' info={phone} editable />
                <InfoItem title='Email' info={email} editable />
                <InfoItem title='Programme' info='Early Years Department (EYD)' />
                <Space  >
                    <Tag color={LeadStatus?.color} style={{ borderRadius: 8 }} >{LeadStatus?.text} </Tag>
                    <Icon fontSize={27} icon="mdi:border-color" color="var(--color-white)" style={{ cursor: 'pointer' }} onClick={showModal} />
                </Space>
                <CustomModal title='Change status' open={open} handleOk={handleOk} confirmLoading={confirmLoading} handleCancel={handleCancel} >
                    <AddStatusModalContent status={status} value={radioValue} setValue={setRadioValue} />
                </CustomModal>
                {/* </Space> */}

            </Col>
            <Col lg={{ span: 1 }} sm={{ span: 2 }} xs={{ span: 0 }}>
                <Divider type='vertical' style={{ height: '100%', background: 'lightgrey' }} />
            </Col>
            <Col sm={{ span: 0 }} xs={{ span: 24 }}>
                <Divider type='horizontal' style={{ background: 'lightgrey' }} />
            </Col>
            <Col lg={{ span: 5 }} sm={{ span: 11 }} xs={{ span: 24 }} >
                <Space direction="vertical" size="middle">
                    <InfoItem title='Location' info={`${country}, ${city}`} />
                    <InfoItem title='Date' info={date} />
                </Space>
            </Col>
            <Col lg={{ span: 1 }} xs={{ span: 0 }}>
                <Divider type='vertical' style={{ height: '100%', background: 'lightgrey' }} />
            </Col>
            <Col lg={{ span: 0 }} xs={{ span: 24 }}>
                <Divider type='horizontal' style={{ background: 'lightgrey' }} />
            </Col>
            <Col lg={{ span: 4 }} sm={{ span: 11 }} xs={{ span: 24 }} >
                <Space direction="vertical" size="middle">
                    <InfoItem title='Source' info={utm} />
                </Space>
            </Col>
            <Col lg={{ span: 1 }} sm={{ span: 2 }} xs={{ span: 0 }}>
                <Divider type='vertical' style={{ height: '100%', background: 'lightgrey' }} />
            </Col>
            <Col sm={{ span: 0 }} xs={{ span: 24 }}>
                <Divider type='horizontal' style={{ background: 'lightgrey' }} />
            </Col>
            <Col lg={{ span: 5 }} sm={{ span: 11 }} xs={{ span: 24 }} >
                <Space direction="vertical" size="middle">
                    <InfoItem title='Campaign' info={campaign} />
                    <InfoItem title='Device' info='Android' />
                </Space>
            </Col>
        </Row>

    )
}
export default LeadInfo

